<template>
  <a-card :bordered="false">
    <div class="tab">
      可用版本：
      <span
        v-for="(i, idx) in LevelEnumArr"
        :key="idx"
        @click="tabLev(i, idx)"
        style="margin-right: 10px;"
        :class="{ color: idx === num }"
      >{{ i.key }}</span
      >
    </div>
    <custom-page-list
      style="margin-top: 20px"
      :grid="{ gutter: 15, column: 6 }"
      :page-size="12"
      :load-data="getServerListPromise"
      ref="pageList"
    >
      <template slot="list-item" slot-scope="row">
        <a-row :gutter="60">
          <a-col class="gutter-row" :span="20">
            <div class="gutter-main">
              <div class="gutter-box">
                <img class="listImg" :src="row.item.subjectBanner"/>
                <div class="bg"></div>
                <a-button class="listBtn" @click="lookImg(row.item)">预览</a-button>
              </div>
              <p class="gutter-p">
                <span>{{ row.item.subjectName }}</span>
                <a class="btn" @click="addTheme(row.item)" v-if="row.item.isHaveSubject == 1">制作专题</a>
                <a class="btn btn2" v-else @click="onDetail">升级版本</a>
              </p>
            </div>
          </a-col>
        </a-row>
      </template>
    </custom-page-list>
    <a-modal title="预览" v-model="visible" :footer="null" width="500px">
      <img class="dialogImg" :src="imgurl"/>
    </a-modal>
  </a-card>
</template>

<script>
import CustomPageList from '../../../../customComponents/CustomPageList'
import searchForm from '../../../../utils/mixins/searchFormMixins'
import SpecialMixins from './SpecialMixins'

export default {
  name: 'ServiceThemeTemplate',
  mixins: [searchForm, SpecialMixins],
  components: { CustomPageList },
  data() {
    return {
      queryParams: {},
      visible: false,
      imgurl: '',
      LevelEnumArr: [],
      subjectLevel: '',
      num: 0
    }
  },
  created() {
  },
  mounted() {
  },
  activated() {
    this.getTypeEnum()
  },
  methods: {
    getTypeEnum() {
      this.getHttpServices().getServerApiService().post('getSubjectVersionLevelEnum').then(res => {
        this.LevelEnumArr = res
        let arr = {
          key: '不限',
          value: ''
        }
        this.LevelEnumArr.unshift(arr)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    tabLev(i, idx) {
      this.num = idx
      this.subjectLevel = i.value
      this.$refs.pageList.refresh(true)
    },
    getServerListPromise(params) {
      let queryParams = {
        limitDto: {
          ...params
        },
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId,
        subjectLevel: this.subjectLevel
      }
      return this.getHttpServices().getServerApiService().post('getSubjectList', queryParams)
    },
    onDetail() {
      //跳转升级购买页面
      this.$router.push({
        name: 'ServiceDetail',
        query: {
          serverId: this.$route.query.serverId,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    },
    lookImg(row) {
      this.visible = true
      this.imgurl = row.subjectBanner
    },
    addTheme(row) {
      this.$router.push({
        name: 'AddThemeTemplate',
        query: {
          subjectId: row.subjectId,
          serverId: this.$route.query.serverId,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@import '../../../CustomPage';

.tab {
  span {
    display: inline-block;
    padding: 5px 20px;
    cursor: pointer;
  }

  span.color {
    background-color: #409eff;
    border-radius: 4px;
    color: #fff;
  }
}

.gutter-main {
  border: 1px #e9e9e9 solid;
}

.gutter-box {
  position: relative;
  height: 250px;
  overflow: hidden;

  .bg {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0.3;
    background-color: #000;
  }

  .listBtn {
    background-color: #ccc;
    width: 60px;
    position: absolute;
    left: 50%;
    margin-left: -30px;
    top: 100px;
    z-index: 1;
  }
}

.listImg {
  width: 100%;
}

.gutter-p {
  padding: 5px;

  span {
    display: inline-block;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
  }

  .btn {
    display: flex;
    justify-content: flex-end;
    padding-right: 5px;
    color: #409eff;
  }

  .btn.btn2 {
    color: red;
  }
}

.dialogImg {
  width: 450px;
}
</style>